import { HeaderSticky } from '~/components/Header';
import { T } from '~/components/I18n';
import { LevelUpRequirementList } from '~/components/LevelUp/Card/Requirement/LevelUpRequirementList';
import { LevelUpFormHeroButton } from '~/components/LevelUp/Form/Hero/LevelUpFormHeroButton';
import './LevelUpSticky.scss';

export const LevelUpSticky = () => (
  <HeaderSticky className="level-up-sticky" rootMargin="-132px 0px">
    <div className="level-up-sticky-requirement">
      <p className="level-up-sticky-requirement-title">
        <T name="citizen_membership_levelup_floating_title" />
      </p>
      <LevelUpRequirementList className="level-up-sticky-requirement-list" />
    </div>
    <LevelUpFormHeroButton />
  </HeaderSticky>
);
